interface ProjectCardProps {
  image: string;
  title: string;
  description: string;
  linkHref?: string;
}

export default function ProjectCard({ image, title, description, linkHref }: ProjectCardProps) {
  const CardContent = (
    <div className="flex flex-col bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-2xl transition-transform duration-300 transform hover:-translate-y-2">
      <img src={image} alt={title} className="w-full h-50 object-cover" />
      <div className="flex flex-col flex-grow p-6">
        <h3 className="text-2xl font-bold text-gray-800 mb-4">{title}</h3>
        <p className="text-gray-600 mb-6 flex-grow">{description}</p>
      </div>
    </div>
  );

  return linkHref ? (
    <a href={linkHref} target="_blank" rel="noopener noreferrer">
      {CardContent}
    </a>
  ) : (
    CardContent
  );
}
